import { Component } from '@angular/core';
import { StorageService } from '../../../services/StorageService';
import { VenueService } from '../../../services/VenueService';
import { Apiservice } from '../../../services/ApiService';
import { timer } from 'rxjs';

@Component({
  selector: 'app-scan-history',
  templateUrl: './scan-history.component.html',
  styleUrls: ['./scan-history.component.scss', '../styles/shared.scss' ]
})
export class ScanHistoryComponent {
  Selectedvenue: string = '';
  venueValue: string = '';
  venuelist: any[] = [];
  date: string = '';
  currentDate = new Date( new Date().getTime() + 14 * 3600 * 1000).toISOString().replace( / GMT$/, "" ).split("T")[0];
  barcode: string = '';
  section: string = '';
  row: string = '';
  seat: string = '';
  scanHistorySummary: any[] = [];
  loading: boolean = false;
  endDate: string = '';
  dateRange: boolean = false;

  constructor(private storage: StorageService, public venue: VenueService, private apiservice: Apiservice) {
   }


  onVenueChange(){
    this.storage.saveVenue(this.Selectedvenue);
    const selectedVenueObj = this.venuelist.find(venue => venue.key === this.Selectedvenue);
    this.venueValue = selectedVenueObj ? selectedVenueObj.value: '';
  }

  onDateChange(){
    this.storage.saveDate(this.date);
    if(this.Selectedvenue !== ''){

    }
  }


  onBarcodeChange(event: any){
    this.barcode = event?.target?.value;
  }

  onSectionChange(event: any){
    this.section = event?.target?.value;
  }

  onRowChange(event: any){
    this.row = event?.target?.value;
  }

  onSeatChange(event: any){
    this.seat = event?.target?.value;
  }



  getVenueList(){
    this.loading = true;
    this.venue.getVenueList().subscribe((data:any) => {
      this.venuelist = data;
      this.loading = false;

    });
  }

  clearFields() { 
    this.barcode = '';
    this.section = '';
    this.row = '';
    this.seat = '';
    this.date = '';
    this.endDate = '';
    this.scanHistorySummary = [];
  }

  getScanHistory(event: any): void {
    this.loading = true;
    this.apiservice.getScanHistoryV2(this.Selectedvenue, this.barcode, this.date,this.endDate, this.section, this.row, this.seat)
      .subscribe((result: any) => {
        result.sort((a: any, b: any) => {
          return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
        });
  
        this.scanHistorySummary = result.map((scan: any) => {

          this.loading = false;
          return {
            ...scan,
            formattedDateTime: this.formatDate(new Date(scan.dateTime))
          };
          
        });
      });
  }

  formatDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric', month: 'long', day: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options);
  }

  selectDateRangeChangeHandler(event: any) {
    if(event.target.checked) {
    this.dateRange = true;
    this.endDate = this.date;
    this.date = '';
  }
    else{
      this.dateRange = false;
      this.date = this.endDate
      this.endDate = '';
    }
  }

  toggleDateRangeCheckBox(){
    if (this.dateRange == true){
      return true;
    }
    else{
      return false;
    }
  }






  ngOnInit(): void {
  
    this.loading = true;
    const savedVenue = this.storage.getVenue();
    if (savedVenue) {
      this.Selectedvenue = savedVenue;
    }
    this.getVenueList();
   

}

}

